import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import axios from 'axios'
import 'vant/lib/index.css'
import './assets/font/iconfont.css'
import VueScroller from 'vue-scroller'
import infiniteScroll from 'vue-infinite-scroll'
import less from 'less'

Vue.use(less)
Vue.use(Vant).use(VueScroller).use(infiniteScroll)

Vue.config.productionTip = false

// axios.defaults.baseURL = 'https://apinew.5kjs.com/activity.compete_ratio'
axios.defaults.baseURL = 'http://api.xueba.hk/activity.query_score' // 本地
Vue.prototype.$http = axios
// Vue.prototype.$url = 'http://api.xueba.hk/activity.query_score'
Vue.prototype.$url = 'https://apinew.5kjs.com/activity.compete_ratio' //线上
// Vue.prototype.$url = 'http://api.xueba.hk/activity.compete_ratio'//本地
// Vue.prototype.$url = 'https://apinew.5kjs.com/activity.query_score'
Vue.prototype.$logo = 'https://apinew.5kjs.com/m/logout' //线上
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
